import types from '../../types';

const historyReplenishment = (
  state = { data: null, loading: true },
  { type, payload },
) => {
  switch (type) {
    case types.GET_REPLENISHED_HISTORY_START:
      return { ...state, loading: true };

    case types.GET_REPLENISHED_HISTORY_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_REPLENISHED_HISTORY_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default historyReplenishment;
